import PropTypes from 'prop-types';
import {
    DimensionAggregationModel,
    MeasureAggregationModel
} from '../models/pipeline/steps/dataset/aggregations/aggregation_model';
import DimensionModel from '../models/pipeline/steps/dataset/dimension';
import ColumnModel from '../models/pipeline/steps/dataset/column';
import FilterModel from '../models/pipeline/steps/dataset/filter';
import MeasureModel from '../models/pipeline/steps/dataset/measure';

export const MENUS = {
    COLUMN: 'column',
    COLUMN_AND_AGG: 'column+agg',
    COMBINED_AGG: 'combined-aggregation',
    AGGREGATION: 'aggregation',
    FILTER_OPERATOR: 'filter operator',
    FILTER_VALUE: 'filter value',
    FILTER_LOGICAL_OPERATOR: 'filter logical operator',
};

export const ATTRIBUTES = {
    MEASURE: 'measure',
    DIMENSION: 'dimension',
    FILTER: 'filter',
    COLUMN: 'column',
};

export const NEXT_MENU = {
    [ATTRIBUTES.MEASURE]: {
        [MENUS.COLUMN]: MENUS.AGGREGATION,
        [MENUS.AGGREGATION]: MENUS.COLUMN,
        [MENUS.COLUMN_AND_AGG]: MENUS.COLUMN_AND_AGG,
    },
    [ATTRIBUTES.DIMENSION]: {
        [MENUS.COLUMN]: MENUS.COLUMN,
    },
    [ATTRIBUTES.FILTER]: {
        [MENUS.COLUMN]: MENUS.FILTER_OPERATOR,
        [MENUS.FILTER_OPERATOR]: MENUS.FILTER_VALUE,
        [MENUS.FILTER_VALUE]: MENUS.COLUMN,
        [MENUS.FILTER_LOGICAL_OPERATOR]: MENUS.COLUMN,
    },
    [ATTRIBUTES.COLUMN]: {
        [MENUS.COLUMN]: MENUS.COLUMN,
    },
};

export const INPUT_ACTIONS = {
    ARROW_DOWN: 'ArrowDown',
    ARROW_UP: 'ArrowUp',
};

export const QUERY_BUILDER_TYPES = {
    COLUMN_FIRST: 'column-first',
    SINGLE_INPUT: 'single-input',
    HYBRID: 'hybrid',
};

export const datasetAttributePropType = PropTypes.oneOfType([
    PropTypes.instanceOf(MeasureModel),
    PropTypes.instanceOf(DimensionModel),
    PropTypes.instanceOf(FilterModel),
    PropTypes.instanceOf(ColumnModel),
]);

export const aggregationPropType = PropTypes.oneOfType([
    PropTypes.instanceOf(MeasureAggregationModel),
    PropTypes.instanceOf(DimensionAggregationModel),
]);

export function createDatasetAttribute(type, dataset = {}, data = {}) {
    data = Object.assign({datasetId: dataset.id}, data);
    switch (type) {
        case ATTRIBUTES.MEASURE:
            return new MeasureModel(data);
        case ATTRIBUTES.DIMENSION:
            return new DimensionModel(data);
        case ATTRIBUTES.FILTER:
            return new FilterModel(data);
        case ATTRIBUTES.COLUMN:
            return new ColumnModel(data);
        default:
            return;
    }
}
